import { EmailForm } from "components/foundation/EmailForm";
import { useBreakpoints } from "hooks/useBreakpoints";

export const Subheading = () => (
  <p className="mx-auto mt-24 mb-40 max-w-md text-14-20 leading-[22px] text-gray-700 md:max-w-xl md:text-20-32 ">
    <span className="font-bold">Customize and optimize</span> your LLM
    applications with the toolkit to ship differentiated products with AI.{" "}
    {/* <span className="rounded-sm bg-blue-200 px-1 py-2 text-gray-800"> */}
    {/* Log, experiment, train and deploy with the platform <br />
    <span className="font-bold">
      powering the next generation of AI companies
    </span> */}
  </p>
);

export const Subheading2 = () => (
  <p className="mx-auto mt-24 mb-40 max-w-md text-14-20 leading-[22px] text-gray-700 md:max-w-xl md:text-20-32 ">
    Deploy differentiated products on top of transformative AI. <br />
    {/* <span className="rounded-sm bg-blue-200 px-1 py-2 text-gray-800"> */}
    with the platform powering the next generation of companies.
  </p>
);

export const FoundationHeroLLMs = () => {
  const { isMediumWidth } = useBreakpoints();
  return (
    <div className="container-lg grid-12 mx-auto text-center  selection:border selection:bg-blue-200">
      <div className="col-span-full text-center">
        <h1 className="mx-auto mt-40 max-w-4xl font-display text-[44px] leading-[48px] md:text-[72px] md:leading-[88px]">
          The platform for <br />
          <span className="rounded-lg bg-blue-200 px-6 pt-4  text-gray-900">
            Large Language Models
          </span>{" "}
        </h1>
        <Subheading />

        <div className="mx-auto max-w-md md:max-w-lg">
          <EmailForm />
        </div>
      </div>
    </div>
  );
};
